export const themes = {
  sytnerTheme: {
    '--background': '#0e76bd',
    '--body-background': '#e4e5ea',
    '--number-plateBG': '#fff',
    '--lp-backgroung-image':'url(assets/images/nl-lip.png)',
    '--lp-backgroung-image-sm':'url(assets/images/nl-lip-sm.png)',
    '--lp-nl-backgroung-image-sm':'url(assets/images/nl-lip.png)',
    '--lp-no-backgroung-image-sm':'url(assets/images/no-lip.png)',
    '--lp-gb-backgroung-image-sm':'url(assets/images/gb-lip.png)',
    '--lp-fi-backgroung-image-sm':'url(assets/images/fi-lip.png)',
    'logoPath': 'assets/images/autofacets.png',
    'currencyType':'GBP',
    'favicon': 'assets/images/SYTNER_favicon.ico'
  }
}
